<template>
  <div
    class="message-detail-container"
    v-if="messages.length > 0"
  >
    <div
      v-for="(item, index) in messages"
      :key="item._id"
    >
      <MessageDetailTable :message="item" />

      <!-- Toggle button for every message -->
      <div
        class="toggle-details-button"
        @click="toggleMessageDetails(item)"
      >
        <i
          :class="
            item.detailsVisible
              ? 'fa fa-angle-double-up toggle-details-icon'
              : 'fa fa-angle-double-down toggle-details-icon'
          "
        ></i>
        <p class="toggle-details-text">詳細</p>
      </div>

      <MessageDetail
        :message="item"
        company="company"
        v-if="item.detailsVisible"
      />
    </div>
  </div>
</template>

<script>
import MessageDetailTable from './MessageDetailTable.vue';
import MessageDetail from './MessageDetail.vue';

export default {
  name: 'MessageList',
  props: {
    messages: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  components: {
    MessageDetailTable,
    MessageDetail,
  },
  methods: {
    toggleMessageDetails(item) {
      item.detailsVisible = !item.detailsVisible;
      this.$emit('messageToggled', item);
    },
  },
};
</script>

<style scoped>
.message-detail-container {
  margin-top: 10px;
  padding: 8px;
  background-color: #fff;
}

.toggle-details-button {
  text-align: center;
  cursor: pointer;
  background-color: #ebeff1;
}

.toggle-details-icon {
  color: #617776;
  font-size: 1.5rem;
  margin-top: 0.5rem;
}

.toggle-details-text {
  display: inline-block;
  position: relative;
  bottom: 5px;
  font-size: 14px;
  color: #617776;
}
</style>

